<script>
	import {
		apis
	} from '@/utils/api.js';
	import {
		userStore
	} from '@/stores/user.js';
	import {
		configStore
	} from '@/stores/config.js';
	import sensors from 'sa-sdk-javascript'
	import {
		initializeApp
	} from "firebase/app";
	import {
		getAnalytics,
		getGoogleAnalyticsClientId
	} from "firebase/analytics";

	const osName = uni.getSystemInfoSync().osName
	const uniPlatform = uni.getSystemInfoSync().uniPlatform
	const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;
	const parseCookies = (cookieString) => {
		const cookies = {};
		if (cookieString === '') return cookies;
		cookieString.split('; ').forEach(kv => {
			const [k, v] = kv.split('=');
			cookies[k] = v;
		});
		return cookies;
	};
	// import VConsole from 'vconsole';

const setSourceid = (sourceid) => {
    if (!sourceid) return;
    const now = Date.now();
    const storageData = {
        data: sourceid,
        timestamp: now,
        expireTime: now + THIRTY_DAYS
    };
    // 存储到 localStorage
    try {
        uni.setStorageSync('sourceid_data', JSON.stringify(storageData));
        uni.setStorageSync('sourceid', sourceid); // 直接存储一份方便使用
    } catch (e) {
        console.error('存储失败:', e);
    }
};

const getSourceid = () => {
    try {
        const storageStr = uni.getStorageSync('sourceid_data');
        if (!storageStr) return null;
        const storageData = JSON.parse(storageStr);
        const now = Date.now();
        // 检查是否过期
        if (now > storageData.expireTime) {
            // 过期，清理
            uni.removeStorageSync('sourceid_data');
            uni.removeStorageSync('sourceid');
            return null;
        }
        // 未过期，返回值
        return storageData.data;
    } catch (e) {
        console.error('获取 sourceid 失败:', e);
        return null;
    }
};


	export default {
		onLaunch: function(e) {
			const urlParams = new URLSearchParams(window.location.search);
			const channel = urlParams.get('channel') || '';
			const sourceid = urlParams.get('sourceid') || '';
			if (channel) {
				uni.setStorageSync('channel', channel)
			}
			if (sourceid) {
				let chan = uni.getStorageSync('channel')
				// uni.setStorageSync('sourceid',sourceid)
				if (chan == 'google' || chan == 'tiktok' || chan == 'facebook') {
					uni.removeStorageSync('sourceid');
					uni.removeStorageSync('sourceids');
				} else {
					setSourceid(sourceid);
				}
			}
			const storedSourceid = getSourceid() || uni.getStorageSync('sourceid');
			if (storedSourceid) {
			    uni.setStorageSync('sourceid', storedSourceid); // 直接存储一份方便使用
			}
			// const vConsole = new VConsole();
			// 语言环境设置为西班牙
			uni.setLocale('es');
			// 初始化用户数据
			console.log('App Launch');
			uni.$api = apis;
			if (channel == 'google' && osName == 'android') {
				setTimeout(() => {
					window.location.href = 'kz://page'; //schema链接或者universal link
				}, 200)

				setTimeout(() => {
					var u = navigator.userAgent;
					if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(u)) {
						var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
						var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
						if (isAndroid == true) {
							location.href =
								"https://play.google.com/store/apps/details?id=loan.mfo.credit.tez.money.cash.zaim.pay.bank.card"
						} else {
							location.href =
								"https://play.google.com/store/apps/details?id=loan.mfo.credit.tez.money.cash.zaim.pay.bank.card"
						}
					} else {
						location.href =
							"https://play.google.com/store/apps/details?id=loan.mfo.credit.tez.money.cash.zaim.pay.bank.card"
					}
				}, 800)
			}
			const store = userStore();
			store.initUserData("initUserStepData");
			const cstore = configStore();
			cstore.initConfigData();
			const firebaseConfig = {
				apiKey: "AIzaSyDgH3qLSUs7xQKE_1u4epm8IfRaAIIZu5Y",
				authDomain: "fcreditkz.firebaseapp.com",
				projectId: "fcreditkz",
				storageBucket: "fcreditkz.firebasestorage.app",
				messagingSenderId: "984977362351",
				appId: "1:984977362351:web:8a6c6e4f1266ddaacd335a",
				measurementId: "G-SRGXEFYPF5"
			};

			const app = initializeApp(firebaseConfig);
			const analytics = getAnalytics(app);
			getGoogleAnalyticsClientId(analytics).then(ret => {
				uni.setStorageSync('analytics', ret);
			})
			const cookiesObj = parseCookies(document.cookie);
			if (cookiesObj._fbp) {
				uni.setStorageSync('fbp', cookiesObj._fbp);
			}
			if (cookiesObj._fbc) {
				uni.setStorageSync('fbc', cookiesObj._fbc);
			}
			if (cookiesObj._ttp) {
				uni.setStorageSync('ttp', cookiesObj._ttp);
			}

			sensors.init({
				// server_url: 'https://sen.fcredit.kz/sa?project=Kazakhstan_Test', //测试
				server_url: 'https://sen.fcredit.kz/sa?project=Kazakhstan', //正式
				is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
				use_client_time: true,
				send_type: 'beacon',
				show_log: false,
				heatmap: {
					//是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
					clickmap: 'not_collect',
					//是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
					scroll_notice_map: 'not_collect'
				}
			});
			const presetProperties = sensors.getPresetProperties();
			uni.setStorageSync('distinctid', presetProperties._distinct_id)

			const ttclid = urlParams.get('ttclid') || '';
			const click_id = urlParams.get('click_id') || '';
			const utm_term = urlParams.get('utm_term') || '';
			const lead_id = urlParams.get('lead_id') || '';
			const aff_sub = urlParams.get('aff_sub') || '';
			const partner_id = urlParams.get('partner_id') || '';
			if (ttclid) {
				uni.setStorageSync('ttclid', ttclid)
			}
			if (click_id) {
				uni.setStorageSync('click_id', click_id)
			}
			if (lead_id) {
				uni.setStorageSync('lead_id', lead_id)
				uni.removeStorageSync('utm_term')
				uni.removeStorageSync('aff_sub')
				uni.removeStorageSync('partner_id')
			}
			if (utm_term) {
				uni.setStorageSync('utm_term', utm_term)
				uni.removeStorageSync('lead_id')
				uni.removeStorageSync('aff_sub')
				uni.removeStorageSync('partner_id')
			}
			if (aff_sub) {
				uni.setStorageSync('aff_sub', aff_sub)
				uni.removeStorageSync('utm_term')
				uni.removeStorageSync('lead_id')
				uni.removeStorageSync('partner_id')
			}
			if (partner_id) {
				uni.setStorageSync('partner_id', partner_id)
				uni.removeStorageSync('lead_id')
				uni.removeStorageSync('aff_sub')
				uni.removeStorageSync('utm_term')
			}
			apis.home.channeladd().then(res => {})
		},
		onShow: function(option) {
			if (uniPlatform != 'web') {
				var args = plus.runtime.arguments
				if (args) {
					const queryString = args.split('?')[1];
					const params = {};
					if (queryString) {
						const pairs = queryString.split('&');
						pairs.forEach(pair => {
							const [key, value] = pair.split('=');
							params[decodeURIComponent(key)] = decodeURIComponent(value);
						});
					}
					uni.setStorageSync('source', params)
					uni.reLaunch({
						url: '/pages/home/index'
					})
				}
			} else {
				const urlParams = new URLSearchParams(window.location.search);
				const source = urlParams.get('source') || '';
				if (source) {
					uni.reLaunch({
						url: '/pages/home/index'
					})
				}
			}
			console.log('App Show');
		},
		onLoad: function(e) {
			console.log(e);
		},
		onHide: function() {
			if (uni.getStorageSync('onHidetimesshow')) {
				uni.setStorageSync('onHidetime', new Date().getTime())
			}
			console.log('App Hide');
		}
	};
</script>
<style>
	/* @font-face {
  font-family: 'PoppinsBold';
  src: url('/static/font/Roboto-Bold.ttf') format('truetype');
  font-weight: bold;
}

@font-face {
  font-family: 'PoppinsRegular';
  src: url('/static/font/Roboto-Black.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'BoldItalic';
  src: url('/static/font/Roboto-BoldItalic.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'RobotoCondensedBold';
  src: url('/static/font/RobotoCondensed-Bold.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'Italic';
  src: url('/static/font/RobotoCondensed-Italic.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'RobotoCondensedLight';
  src: url('/static/font/RobotoCondensed-Light.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'LightItalic';
  src: url('/static/font/RobotoCondensed-LightItalic.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'Regular';
  src: url('/static/font/RobotoCondensed-Regular.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'RobotoLight';
  src: url('/static/font/Roboto-Light.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'LightItalic';
  src: url('/static/font/Roboto-LightItalic.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'Medium';
  src: url('/static/font/Roboto-Medium.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'RobotoRegular';
  src: url('/static/font/Roboto-Regular.ttf') format('truetype');
  font-weight: normal;
}
@font-face {
  font-family: 'RobotoThin';
  src: url('/static/font/Roboto-Thin.ttf') format('truetype');
  font-weight: normal;
} */
	/*每个页面公共css */
	.full-screen {
		/* #ifdef APP-PLUS */
		position: fixed;
		/* #endif */
		/* #ifndef APP-PLUS */
		position: fixed !important;
		/* #endif */
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
	}

	.items-center {
		display: flex;
		/* #ifdef APP-PLUS */
		align-items: center;
		/* #endif */
		/* #ifndef APP-PLUS */
		align-items: center !important;
		/* #endif */
	}

	.justify-center {
		display: flex;
		/* #ifdef APP-PLUS */
		justify-content: center;
		/* #endif */
		/* #ifndef APP-PLUS */
		justify-content: center !important;
		/* #endif */
	}

	.justify-between {
		display: flex;
		/* #ifdef APP-PLUS */
		justify-content: space-between;
		/* #endif */
		/* #ifndef APP-PLUS */
		justify-content: space-between !important;
		/* #endif */
	}

	.items-end {
		display: flex;
		/* #ifdef APP-PLUS */
		align-items: flex-end;
		/* #endif */
		/* #ifndef APP-PLUS */
		align-items: flex-end !important;
		/* #endif */
	}

	.items-start {
		display: flex;
		/* #ifdef APP-PLUS */
		align-items: flex-start;
		/* #endif */
		/* #ifndef APP-PLUS */
		align-items: flex-start !important;
		/* #endif */
	}

	.flex-col {
		display: flex;
		/* #ifdef APP-PLUS */
		flex-direction: column;
		/* #endif */
		/* #ifndef APP-PLUS */
		flex-direction: column !important;
		/* #endif */
	}

	.flex-row {
		display: flex;
		/* #ifdef APP-PLUS */
		flex-direction: row;
		/* #endif */
		/* #ifndef APP-PLUS */
		flex-direction: row !important;
		/* #endif */
	}

	/* #ifdef H5 */
	body {
		background-color: #fff;
	}

	/* #endif */
	.swiper .uni-swiper-wrapper .uni-swiper-dots-horizontal .uni-swiper-dot-active {
		width: 32rpx !important;
		height: 16rpx !important;
		border-radius: 8rpx !important;
	}
</style>
<style lang="scss">
</style>